import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsService {
  key = environment.googleMapsKey;
  mapsApiUrl = "https://maps.googleapis.com/maps/api/";

  private http:HttpClient;
  constructor(handler: HttpBackend) 
  { 
    this.http = new HttpClient(handler);
  }

  public async getStreetViewThumbnail(location, width, height) : Promise<string>{
    let thumbnail;
    await Promise.resolve(this.http.get(`${this.mapsApiUrl}streetview/metadata?location=${location}&key=${this.key}`)
    .toPromise()
    .then((metadata:any) =>{
      if(metadata.status == "OK"){
        //let result_location = `${metadata?.location.lat},${metadata?.location.lng}`;
        thumbnail = `${this.mapsApiUrl}streetview?size=${width}x${height}&location=${location}&key=${this.key}`
      }
    }));

    return thumbnail;
  }
}
